/*
Componente para seleccionar hora, minuto y am/pm
Devuelve el valor de la hora en formato militar a través de la función onChange
*/
import React from "react";
import { useEffect, useState, useRef } from "react";
import { leadingZero } from "../../../resources/Helper";

function SelectorHora(props) {

    const [horaAtencionCita, setHoraAtencionCita] = useState(null);
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();
    const refMinutoCita = useRef();
    const refAmpmCita = useRef();

    useEffect(() => {
        let componenteHora = parseInt(horaAtencionCita);
        let componenteMinutos = minutoCita;
        
        // Convertir de formato 12h a 24h
        if (ampmCita=='pm') {
            if (componenteHora<12) {
                componenteHora = componenteHora + 12;
            }
            // Si es 12pm, se queda en 12
        }

        if (ampmCita=='am') {
            if (componenteHora==12) {
                componenteHora = 0; // 12am = 00:00 (medianoche)
            }
            // Si es 1am-11am, se queda igual
        }

        if (!isNaN(componenteHora)&&!isNaN(componenteMinutos)) {
            let hora = leadingZero(componenteHora)+':'+componenteMinutos+':00';
            props.onChange(hora);
        }
    },[horaAtencionCita,minutoCita,ampmCita]);


    useEffect(() => {
        setHoraAtencionCita(props.horaAtencionCita);
        setMinutoCita(props.minutoCita);
        setAmpmCita(props.ampmCita);
    },[props.horaAtencionCita,props.minutoCita,props.ampmCita]);


    useEffect(() => {
        if (horaAtencionCita) {
            setMinutoCita('00');
            //setAmpmCita('am');
            refMinutoCita.current.value = "00";
            //refAmpmCita.current.value = "am";
            if (!ampmCita) {
                setAmpmCita('am');
                refAmpmCita.current.value = "am";
            }
        }
    },[horaAtencionCita]);

    

    return (
        <>
            <div className="control-hora">

                <select className="form-control" defaultValue={props.horaAtencionCita} onChange={(e) => setHoraAtencionCita(e.target.value)}>
                    <option value=""></option>
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                </select>
                <select className="form-control" defaultValue={props.minutoCita} ref={refMinutoCita} onChange={(e) => setMinutoCita(e.target.value)}>
                    <option value=""></option>
                    <option value="00">00</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="45">45</option>
                </select>
                <select className="form-control" defaultValue={props.ampmCita} ref={refAmpmCita} onChange={(e) => setAmpmCita(e.target.value)}>
                    <option value=""></option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                </select>
            </div>
        </>
    )
}
export default SelectorHora;